export default __webpack_public_path__ + "static/media/hacksaw-mono.66411380.svg";